<template>
  <div class="main">
    <suspension @slide="scrollTo($event)"></suspension>
    <!-- 顶部图片部分 -->
    <div class="banner">
      <div class="banner_content">
        <a href="javascript:;">
          <div class="banner_nav1" @click="scrollTo(0)">
            <div>活动首页</div>
          </div>
        </a>
        <a href="javascript:;">
          <div class="banner_nav2" @click="scrollTo('#card')">
            <div>打卡进行时</div>
          </div>
        </a>
        <a href="javascript:;">
          <div class="banner_nav3">
            <router-link to="/index/lookBack"
              ><div @click="scrollTo('.center')">往期回顾</div></router-link
            >
          </div>
        </a>
        <a href="javascript:;">
          <div class="banner_nav4">
            <router-link to="/index/share"
              ><div @click="scrollTo('.center')">学员打卡日记</div></router-link
            >
          </div>
        </a>
        <a href="javascript:;">
          <div class="banner_nav5" @click="scrollTo('#QA')">
            <div>常见问题Q&A</div>
          </div>
        </a>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import suspension from "@/components/suspension.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Main",
  components: { suspension },
  data() {
    return {};
  },
  computed: {
    ...mapState(["carDefaultRouter"]),
  },
  methods: {
    ...mapMutations(["login"]),
    //页面滑动效果
    scrollTo(event) {
      let carDefaultRouter = sessionStorage.getItem("router");
      var url = window.location.href;
      // 如果是在往期回顾和打卡分享里面不能点击跳转自己
      if (event == ".center") {
        let backLook = url.search(/lookBack/);
        let share = url.search(/share/);
        if (backLook != -1 || share != -1) {
          return;
        }
      }
      // var hasIndex = /index/
      var status = url.search(/home/);
      if (status == -1) {
        console.log("路由跳转");
        this.$router.push({ path: "/index/home/card/" + carDefaultRouter });
        // this.scrollTo(0)
        // var el = document.querySelector("html")
        // console.log(el)
      }
      setTimeout(() => {
        // event为需要跳转的锚点元素ID，如果event为0则返回顶部
        if (event == 0) {
          var y = 0;
          3;
        } else {
          var thisevent = document.querySelector(event);
          // offsetTop为元素到顶部的距离
          if (event == "#share") {
            y = event.offsetTop + 970;
          } else {
            y = thisevent.offsetTop - 100;
          }
        }
        let duration = 500;
        /*y:目标纵坐标,duration:时间(毫秒)*/
        var scrollTop = document.documentElement.scrollTop;

        /*页面当前滚动距离*/
        var distance =
          y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
        var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
        var everyDistance =
          distance / scrollCount; /*滚动距离除以滚动次数计算每次滚动距离*/
        for (
          var index = 1;
          index <= scrollCount;
          index++ /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
        )
          setTimeout(function () {
            window.scrollBy(0, everyDistance);
          }, 10 * index);
      }, 0);
    },
  },
  async mounted() {},
  created() {
    // 分销参数
    let distrid = this.$route.query.distrid;
    if (distrid != null) {
      sessionStorage.setItem("distrid", distrid);
    } else {
      sessionStorage.removeItem("distrid");
    }
    //  获取登录token以及科目类编由于涉及多次跨域这里暂时注释，上线之后在请求，
    let url = window.location.origin;
    url = url + "/getInfo";
    this.$axios
      .get(url)
      .then((doc) => {
        if (doc.token != null) {
          localStorage.setItem("token", doc.token);
          localStorage.setItem("agency_id", doc.agency_id);
          this.login(doc);
        } else {
          localStorage.setItem("agency_id", doc.agency_id);
          localStorage.removeItem("token");
          this.login(doc);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fed7b0;
  overflow: hidden;
  //   内容头部
  .banner {
    position: relative;
    width: 100%;
    height: 67.5rem;
    background: url("https://fview.5kjs.com/activity/21sign/image/pc/banner.216d6d8e.png")
      no-repeat;
    background-size: 100% 100%;
    .banner_content {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 6.9375rem;
      display: flex;
      align-items: row;
      div {
        margin-right: 0.625rem;
      }
      // 选择所有类名以banner_nav开头的的DIV
      div[class^="banner_nav"]:hover {
        div {
          color: #ff8208 !important;
        }
      }
      .banner_nav1,
      .banner_nav2,
      .banner_nav3,
      .banner_nav4,
      .banner_nav5 {
        box-sizing: border-box;
        padding: 1.5rem 0 2.5625rem 0;
        padding-left: 1.775rem;
        height: 6.125rem;
        font-size: 2.125rem;
        font-family: " SourceHanSansSC";
        font-weight: bold;
        font-style: italic;
        line-height: 2.1375rem;
        div {
          color: #f9502b;
        }
      }

      .banner_nav1 {
        width: 14rem;
        background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/banner_item1.png)
          no-repeat;
        background-size: 100% 100%;
      }
      .banner_nav2 {
        width: 16.1875rem;
        background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/banner_item2.png)
          no-repeat;
        background-size: 100% 100%;
      }
      .banner_nav3 {
        width: 14.0625rem;
        background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/banner_item1.png)
          no-repeat;
        background-size: 100% 100%;
      }
      .banner_nav4 {
        width: 18.25rem;
        background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/banner_item4.png)
          no-repeat;
        background-size: 100% 100%;
      }
      .banner_nav5 {
        width: 18.5625rem;
        background: url(https://fview.5kjs.com/activity/21sign/image/pc/indexImage/banner_item5.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>